/**
 * Tapper | client script
 */ const avgClickTimeField = document.getElementById("avgClickTime");
const levelIcon = document.getElementById("levelIcon");
const levelDescription = document.getElementById("levelDescription");
let lastTimestamps = [];
function calcAvgClickTime() {
    const countTimestamps = lastTimestamps.length;
    if (countTimestamps < 10) return;
    let intervals = [];
    for(let t = countTimestamps - 10; t < countTimestamps - 1; t++){
        let olderTimestamp = lastTimestamps[t];
        let newerTimestamp = lastTimestamps[t + 1];
        const diffSecs = (newerTimestamp - olderTimestamp) / 1000;
        intervals.push(diffSecs);
    }
    let intervalsSum = 0;
    for(let i = 0; i < intervals.length; i++)intervalsSum += intervals[i];
    const avgInterval = intervalsSum / intervals.length;
    return avgInterval;
}
function renderResult(icon, description) {
    levelIcon.innerText = icon;
    levelDescription.innerText = description;
}
function rateResult(clkTime) {
    if (clkTime > 0.3) renderResult("\uD83D\uDC7B", "noob");
    else if (clkTime > 0.225) renderResult("\uD83D\uDE43", "beginner");
    else if (clkTime > 0.2) renderResult("\uD83E\uDD28", "player");
    else if (clkTime > 0.17) renderResult("\uD83E\uDD73", "better player");
    else if (clkTime > 0.16) renderResult("\uD83E\uDD13", "nearly pro");
    else if (clkTime > 0.15) renderResult("\uD83D\uDE0E", "pro");
    else if (clkTime < 0.15) renderResult("\uD83E\uDD16", "der ger\xe4t");
}
function triggerAvgTimeUpdate() {
    const avgClickTime = calcAvgClickTime();
    if (avgClickTime === undefined) return;
    const roundedAvgClickTime = Math.round(avgClickTime * 1000) / 1000;
    avgClickTimeField.innerText = roundedAvgClickTime;
    rateResult(roundedAvgClickTime);
}
document.addEventListener("keydown", (ev)=>{
    if (ev.code === "Space") lastTimestamps.push(new Date());
    triggerAvgTimeUpdate();
});

//# sourceMappingURL=index.c5089eb9.js.map
